import {ClassFlowPhase, StatusMessageBox} from '../../../pages/AutoProject/Config/AutoProject.constants';
import {_INPUT_RULES} from '../../../configuration/index.config';
import {useState} from 'react';

const useAutoProjectImageCollectionTab = () => {
    const [openTrainingModal, setOpenTrainingModal] = useState(false);

    /***
     * updateProjectMessageStatus - return the current message box status of the project
     * @param newClassesStatus - classes and their statuses
     */
    const updateProjectMessageStatus = (newClassesStatus) => {
        const classCounter = newClassesStatus.length;

        if (newClassesStatus.filter((cur) => cur.flowPhase === ClassFlowPhase.TrainingReady &&
            cur.trainingStatus === ClassFlowPhase.Training.Completed).length > 0) {
            return StatusMessageBox.TrainingCompleted;
        } else if (newClassesStatus.filter((cur) => cur.flowPhase === ClassFlowPhase.TrainingReady &&
        cur.trainingStatus === ClassFlowPhase.Training.InProgress).length > 0) {
            return StatusMessageBox.TrainingInProgress;
        } else if (newClassesStatus.filter((cur) => cur.flowPhase === ClassFlowPhase.TrainingReady).length / classCounter * 100 >= _INPUT_RULES.THRESHOLD_PERCENT_FOR_TRAINING) {
            return StatusMessageBox.ReadyForTraining;
        } else if (newClassesStatus.filter((cur) => cur.flowPhase === ClassFlowPhase.ManualRefinementReady).length >= 1) {
            return StatusMessageBox.ReadyForRefinement;
        } else if (newClassesStatus.some((cur) => cur.manualRefinementsCounter > 0)) {
            return StatusMessageBox.OneRefinementCompleted;
        } else if (newClassesStatus.every((cur) => cur.flowPhase === ClassFlowPhase.InCluster || cur.flowPhase === ClassFlowPhase.ManualRefinementProcessPending)) {
            return StatusMessageBox.DataCollection;
        }

        return newClassesStatus.DataCollection;
    };


    return {updateProjectMessageStatus, openTrainingModal, setOpenTrainingModal};
};

export default useAutoProjectImageCollectionTab;
